import { Saga } from 'redux-saga';

class ReduxGraphQLClient {
  public clientFetcherSaga: Saga | undefined;

  public initialize(saga: Saga) {
    this.clientFetcherSaga = saga;
  }

  get getClient(): Saga {
    if (!this.clientFetcherSaga) {
      const message =
        'Cannot use graphql redux methods without initializing the redux graphql client';
      console.error(message);
      throw new Error(message);
    }

    return this.clientFetcherSaga;
  }
}

// This graphql client must be initialized by the consuming application before the sagas calling this will work
export const reduxGraphQL = new ReduxGraphQLClient();
